import type { CSSProperties } from 'react';

import classnames from 'classnames';

import { Icon } from '@/icon';

import { isRenderableSignupIcon } from '../utils/isRenderableSignupIcon';

import type { TIcon } from '../../types';
import * as styles from '../Signup.css';

interface SignupInputProps {
  icon?: TIcon | null;
  inputPlaceholder: string;
  handleEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputStyle: CSSProperties;
}

const SignupInput = ({ icon, inputPlaceholder, handleEmailChange, inputStyle }: SignupInputProps) => {
  const renderableIcon = isRenderableSignupIcon(icon) ? icon : undefined;

  return (
    <div className="flex items-center gap-2 w-full">
      <div className="relative w-full">
        {renderableIcon && (
          <div className={classnames(styles.inputIcon, 'absolute top-1/2 -translate-y-1/2 left-3')}>
            {renderableIcon.type === 'icon' && (
              <Icon
                type={renderableIcon.iconType}
                name={renderableIcon.iconName}
                size={20}
                className={classnames(styles.inputIcon)}
              />
            )}
            {renderableIcon.type === 'emoji' && <span>{renderableIcon.content}</span>}
          </div>
        )}
        <input
          type="email"
          name="email"
          required={true}
          autoComplete="off"
          className={classnames(styles.input, 'w-full pr-4 cursor-text', renderableIcon ? 'pl-10' : 'pl-4')}
          style={inputStyle}
          placeholder={inputPlaceholder}
          onChange={handleEmailChange}
        />
      </div>
    </div>
  );
};

export default SignupInput;
